import React, { memo } from "react"
import { TableNode as TableNodeType } from "@features/builder/graph/types"
import NodeContainer from "./NodeContainer"

export const TableNode = memo((node: TableNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-table">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

TableNode.displayName = "TableNode"
